import {useEffect,useRef,useState} from 'react';
import api,{downloadFile,getErrorMessage} from '@/lib/api';

export default function NativeWordHistory(props){
 return <History key={`${props.id}:${props.exportType}:${props.recordId}`} {...props}/>;
}

const PAGINATION={FIELDS_NOT_CALCULATED:'Field Word, belum dihitung',CALCULATED:'Dihitung oleh renderer',NO_CONTENTS_ENTRIES:'Tanpa entri daftar isi'};
const NOTE_OPTIONS=[['INCLUDE_OPEN_ONLY','Catatan reviu terbuka saja'],['INCLUDE_ALL','Semua catatan reviu'],['EXCLUDE_REVIEW_NOTES','Tanpa catatan reviu']];

function History({id,exportType,recordId,historyPath,templates:allowTemplates=true,reviewNotes=false,pagination:allowPagination}){
 const pagination=allowPagination??!historyPath;
 const [opened,setOpened]=useState(false),[rows,setRows]=useState([]),[next,setNext]=useState(null);
 const [busy,setBusy]=useState(false),[error,setError]=useState('');
 const [templates,setTemplates]=useState(null),[templateId,setTemplateId]=useState('');
 const [noteOption,setNoteOption]=useState('INCLUDE_OPEN_ONLY');
 const request=useRef(0);
 useEffect(()=>()=>{request.current+=1;},[]);
 const load=async(offset=0)=>{
  const ticket=++request.current;setOpened(true);setBusy(true);setError('');setRows([]);setNext(null);
  const query=new URLSearchParams({export_type:exportType,record_id:recordId,offset:String(offset)});
  try{
   const {data}=await api.get(`${historyPath||`/engagements/${id}/word-exports`}?${query}`);
   if(ticket!==request.current)return;
   setRows(data.items||[]);setNext(data.next_offset??null);
  }catch(e){if(ticket===request.current)setError(getErrorMessage(e));}
  finally{if(ticket===request.current)setBusy(false);}
 };
 const download=async(row)=>{
  const ticket=request.current;
  try{await downloadFile(`/word-exports/${row.id}/download`,row.filename);}
  catch(e){if(ticket===request.current){setRows([]);setError(getErrorMessage(e));}}
 };
 const downloadAnnex=async(row,annex)=>{
  const ticket=request.current;
  try{await downloadFile(`/word-exports/${row.id}/annexes/${annex.id}/download`,annex.filename);}
  catch(e){if(ticket===request.current){setRows([]);setError(getErrorMessage(e));}}
 };
 const loadTemplates=async()=>{
  const ticket=++request.current;setBusy(true);setError('');setTemplates(null);setTemplateId('');
  try{
   const collected=[];let offset=0;
   do{
    const {data}=await api.get(`/word-templates?limit=100&offset=${offset}`);
    if(ticket!==request.current)return;
    collected.push(...(data.items||[]));offset=data.next_offset;
   }while(offset!==null&&offset!==undefined);
   setTemplates(collected.filter(t=>t.status==='PUBLISHED'&&t.export_type===exportType));
  }catch(e){if(ticket===request.current)setError(getErrorMessage(e));}
  finally{if(ticket===request.current)setBusy(false);}
 };
 const generate=async()=>{
  const ticket=request.current;setBusy(true);setError('');
  const query=new URLSearchParams({export_type:exportType,record_id:recordId,template_id:templateId});
  try{
   await downloadFile(`/engagements/${id}/word-export?${query}`,'working-copy.docx');
   if(ticket===request.current)await load(0);
  }catch(e){if(ticket===request.current){setRows([]);setError(getErrorMessage(e));}}
  finally{if(ticket===request.current)setBusy(false);}
 };
 const calculated=async()=>{
  const ticket=request.current;setBusy(true);setError('');
  const query=new URLSearchParams({export_type:exportType,record_id:recordId,pagination:'CALCULATED'});
  try{
   await downloadFile(`/engagements/${id}/word-export?${query}`,'paged-copy.docx');
   if(ticket===request.current)await load(0);
  }catch(e){if(ticket===request.current){setRows([]);setError(getErrorMessage(e));}}
  finally{if(ticket===request.current)setBusy(false);}
 };
 const reviewCopy=async()=>{
  const ticket=request.current;setBusy(true);setError('');
  const query=new URLSearchParams({export_type:exportType,record_id:recordId,mode:'REVIEW',review_notes:noteOption});
  try{
   await downloadFile(`/engagements/${id}/word-export?${query}`,'review-copy.docx');
   if(ticket===request.current)await load(0);
  }catch(e){if(ticket===request.current){setRows([]);setError(getErrorMessage(e));}}
  finally{if(ticket===request.current)setBusy(false);}
 };
 return <section className="border rounded p-3 space-y-2 text-xs" aria-label="Riwayat ekspor Word">
  <button type="button" disabled={busy||!recordId} onClick={()=>load(0)} className="border rounded p-2">{opened?'Perbarui riwayat Word saya':'Riwayat Word saya'}</button>
  {allowTemplates&&<button type="button" disabled={busy||!recordId} onClick={loadTemplates} className="border rounded p-2">Pilih templat Word</button>}
  {pagination&&<button type="button" disabled={busy||!recordId} onClick={calculated} className="border rounded p-2">Buat salinan dengan nomor halaman terhitung</button>}
  {allowTemplates&&templates&&<div className="space-y-2">
   <label>Templat terbit<select aria-label="Templat Word terbit" value={templateId} onChange={e=>setTemplateId(e.target.value)} className="block border p-2 max-w-full">
    <option value="">Pilih templat yang sesuai metodologi sumber</option>
    {templates.map(t=><option key={t.id} value={t.id}>{`${t.definition.title} · v${t.version} · ${t.methodology_version} · ${t.definition.language}`}</option>)}
   </select></label>
   {!templates.length&&<p>Belum ada templat terbit untuk jenis ekspor ini.</p>}
   <button type="button" disabled={busy||!templateId} onClick={generate} className="border rounded p-2">Buat Word dengan templat</button>
   <p>Metodologi, lingkup, dan dukungan bahasa diperiksa saat ekspor. Ikatan sumber wajib yang belum tersedia ditandai tidak lengkap.</p>
  </div>}
  {reviewNotes&&<div className="space-y-2">
   <label>Catatan reviu dalam salinan reviu<select aria-label="Pilihan catatan reviu" value={noteOption} onChange={e=>setNoteOption(e.target.value)} className="block border p-2 max-w-full">
    {NOTE_OPTIONS.map(([value,label])=><option key={value} value={value}>{label}</option>)}
   </select></label>
   <button type="button" disabled={busy||!recordId} onClick={reviewCopy} className="border rounded p-2">Buat salinan reviu</button>
   <p>Salinan reviu hanya tersedia setelah reviu independen yang masih berlaku. Catatan reviu disalin apa adanya; ekspor tidak menutup atau menyetujui catatan.</p>
  </div>}
  {busy&&<p>Memuat riwayat…</p>}
  {error&&<p role="alert">{error}</p>}
  {opened&&!busy&&!error&&<>
   <p>Versi ekspor tersimpan terpisah dari revisi sumber. Unduhan memerlukan akses dan sumber yang masih sesuai.</p>
   {!rows.length?<p>Belum ada ekspor Word untuk sumber ini.</p>:<div className="overflow-x-auto"><table className="w-full text-left">
    <thead><tr>{['Versi','Dibuat','Pembuat','Mode','Revisi sumber','Status','Templat','Nomor halaman',...(reviewNotes?['Catatan reviu']:[]),'Berkas / SHA-256'].map(label=><th className="p-2" key={label}>{label}</th>)}</tr></thead>
    <tbody>{rows.map(row=><tr key={row.id}>
     <td className="p-2">{row.version}</td><td className="p-2">{row.generated_at}</td><td className="p-2">{row.generated_by}</td>
     <td className="p-2">{row.mode}</td><td className="p-2">{row.source_version}</td><td className="p-2">{row.status}</td>
     <td className="p-2">{row.template_version?`v${row.template_version}`:'Belum dipilih'} · {row.template_status||'Belum tercatat'}{row.missing_bindings?.length>0&&<div>Belum tersedia: {row.missing_bindings.join(', ')}</div>}</td>
     <td className="p-2">{PAGINATION[row.pagination?.status]||'Field Word, belum dihitung'}{row.pagination?.status==='CALCULATED'?` · ${row.pagination.renderer} · ${row.pagination.pages} hlm`:''}</td>
     {reviewNotes&&<td className="p-2">{row.review_notes||'EXCLUDE_REVIEW_NOTES'}</td>}
     <td className="p-2"><button type="button" disabled={row.status!=='READY'} onClick={()=>download(row)} className="underline">{row.filename}</button><div className="break-all font-mono">{row.sha256}</div>
      {(row.annexes||[]).map(a=><div key={a.id} className="mt-1" data-testid="word-annex">
       <button type="button" disabled={row.status!=='READY'} onClick={()=>downloadAnnex(row,a)} className="underline">{a.filename}</button>
       <div>Lampiran Excel · {a.row_count} baris · {Object.entries(a.totals||{}).map(([k,v])=>`${k} ${v}`).join(' · ')}</div>
       <div className="break-all font-mono">{a.sha256}</div></div>)}</td>
    </tr>)}</tbody></table></div>}
   {next!==null&&<button type="button" onClick={()=>load(next)} className="border rounded p-2">Halaman berikutnya</button>}
  </>}
 </section>;
}
